import * as React from 'react';
import * as classnames from 'classnames';
import styled, { css } from 'styled-components';
import { sliderDotButtonTheme, sliderDotButtonActiveTheme } from '../theme/default-theme';
import { translate } from '@estee/elc-service';
export interface IStyledDotButton {
    isActive: boolean;
}

const StyledDotsList = styled.ul`
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    padding: 0;
    list-style: none;
    text-align: center;
`;

const StyledDot = styled.li`
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
`;

const StyledDotButton = styled.button<IStyledDotButton & React.HTMLProps<HTMLButtonElement>>`
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    border: 0;
    ${sliderDotButtonTheme}
    ${({ isActive }) =>
        isActive &&
        css`
            ${sliderDotButtonActiveTheme};
        `};

    &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
    }
`;

const sliderDotListClassNames = classnames('elc-slider-dot', 'js-slider-dot');

const sliderDotButtonClassNames = classnames('elc-slider-dot-button', 'js-slider-dot-button');

const dotsListClassName = classnames('elc-slider-dots-list', 'js-slider-dots-list');

interface ICustomDotsList {
    dots: React.ReactChild[];
    translations?: ICustomDotTranslations;
}

interface ICustomDotTranslations {
    navigateToSlide?: string;
}

export const CustomDotsList = translate(['navigateToSlide'])((props: ICustomDotsList) => {
    const { translations, dots } = props;
    const { navigateToSlide } = translations as ICustomDotTranslations;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customDots = React.Children.map(dots, (dot: React.ReactElement, dotIndex: number) => {
        let isActive = false;
        let buttonClasses = sliderDotButtonClassNames;
        // identify which dot is active by checking the classname
        if (dot.props.className === 'slick-active') {
            isActive = true;
            buttonClasses += ' elc-slider-dot-button-active';
        }

        return (
            <StyledDot className={sliderDotListClassNames}>
                <StyledDotButton
                    isActive={isActive}
                    className={buttonClasses}
                    onClick={dot.props.children && dot.props.children.props.onClick}
                    aria-label={`${navigateToSlide} ${dotIndex + 1}`}
                />
            </StyledDot>
        );
    });

    return <StyledDotsList className={dotsListClassName}>{customDots}</StyledDotsList>;
});
